import NewStaticTable from "components/staticTable/NewStaticTable";
import Modal from "global/Modal/Modal";
import { useEffect, useState } from "react";
import { getAPI } from "services/CRUDServices";
import { getDay, getPrice } from "tools/functions/Methods";
import { ConsumeColumns } from "./column";

function PaymentDetailCredit({ open, setOpen, currentData }) {
  const [tableData, setTabledata] = useState([]);
  useEffect(() => {
    getAPI(
      `/core-api/hub_credit/findSettlementFromCredit/${currentData.id}`
    ).then((res) => {
      const data = res.data.payload.map((item) => ({
        ...item,
        bankTransactionTime: getDay(item.bankTransactionTime),
        depositPaymentVia:item.depositPaymentVia?.text,
        creditorsLedger:getPrice(item.creditorsLedger)
      }));
      setTabledata(data);
    });
  }, [open]);

  return (
    <>
      <Modal
        visible={open}
        setVisible={setOpen}
        title="جزئیات پرداخت ها"
        className=" w-[30rem]"
      >
        <span>هاب: </span>{" "}
        <span className=" font-semibold">
          {currentData.creditRecipientHub?.name}
        </span>
        <NewStaticTable
          data={tableData}
          THWrapper={"whitespace-nowrap"}
          column={ConsumeColumns}
        />
      </Modal>
    </>
  );
}

export default PaymentDetailCredit;
